// 测试环境配置
export const testConfig = {
  api: {
    baseURL: 'http://localhost:8080',
    version: 'v1',
    path: '/api',
    timeout: 5000, // 测试环境使用较短的超时时间
  },
  env: 'test',
}; 